<template lang="pug">
server-data(
  :method="method"
  v-bind="serverDataAttrs"
  search-field-name="search[name]"
  v-slot="{ selectProps, search, loadMoreItems }"
)
  v-autocomplete-more(
    :value="value"
    v-bind="{ ...selectProps, ...$attrs }"
    :items="selectProps.items"
    :label="label"
    item-text="title"
    v-on="$listeners"
    @input="$emit('input', $event)"
    @update:search-input="search"
    @load-more-items="loadMoreItems"
    @keyup.enter="emitFilters"
  )
    template(v-slot:item="{ item, on, attrs }")
      v-list-item(
        :key="item.id"
        v-on="on"
        v-bind="attrs"
      )
        v-list-item-avatar
          v-img(
            :src="item.image_file_url || require('@/assets/course-sample.png')"
          )
        v-list-item-content
          v-list-item-title {{ item.title }}
          v-list-item-subtitle(v-if="item.type_activity") {{ item.type_activity.name }}
</template>

<script>
export default {
  name: 'SelectCourse',
  props: {
    value: { type: [Number, Object], default: null },
    serverDataAttrs: { type: Object, default: () => ({}) },
    label: { type: String, default: 'Выберите курс' },
    service: { type: Number, default: null },
  },
  methods: {
    method(data) {
      const service = this.service || this.$conf.COURSE_SERVICE.all;
      return this.$api.courses.index(data, service);
    },
  },
};
</script>
